import { APPS_HOME_PATH } from "@/lib/apps";

export interface SettingsBackLink {
  to: string;
  label: string;
}

export function resolveSettingsBackLink(pathname: string): SettingsBackLink {
  if (pathname === "/settings/google-drive" || pathname === "/settings/google-drive/") {
    return { to: APPS_HOME_PATH, label: "Back to apps" };
  }

  return { to: APPS_HOME_PATH, label: "Back to apps" };
}
